'use client';

import { VcVoucherCodeFormStoryblok } from '@/storyblok/types';
import { StoryblokReactComponent } from './componentsMap';
import { storyblokEditable } from '@storyblok/js';
import { FormEventHandler } from 'react';
import { clientEnv } from '@/config/env/client';

export const StoryblokVcVoucherCodeForm: StoryblokReactComponent<VcVoucherCodeFormStoryblok> = ({ component }) => {
  const handleSubmit: FormEventHandler<HTMLFormElement> = async e => {
    const data = new FormData(e.currentTarget);
    e.preventDefault();
    const voucher = data.get('voucher');
    if (typeof voucher !== 'string') return;
    const response = await fetch(`${clientEnv.NEXT_PUBLIC_MARKETING_API_URL}/api/v1/marketing/vc-voucher`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ voucher }),
    });
    if (response.status !== 200) {
      console.error('Error submitting voucher code');
      return;
    }
    window.location.href = component.formAction;
  };

  return (
    <section
      className="relative flex max-w-section flex-col gap-10 pt-11 lg:items-start lg:pt-28 xl:mx-auto"
      {...storyblokEditable(component)}
    >
      <div className="flex w-full flex-col items-center">
        {component.title && (
          <h2 className="relative z-[2] px-9 text-center text-2xl font-semibold text-neutral-darker md:text-3xl   xl:mx-auto xl:inline-block xl:w-full xl:max-w-screen-xl xl:text-4xl">
            {component.title}
          </h2>
        )}
        {component.subtitle && (
          <h3 className="relative z-[2] mt-4  px-14 text-center text-xl font-medium text-neutral-darker  lg:font-medium xl:mx-auto xl:inline-block xl:w-full xl:max-w-screen-xl ">
            {component.subtitle}
          </h3>
        )}
      </div>
      <div className="relative flex w-full flex-row justify-center pb-10 xl:max-w-screen-xl">
        <div className="relative flex flex-col gap-6 rounded-lg border border-black/5 bg-white p-6 ">
          <form className="flex flex-col gap-3 md:grid md:grid-cols-[1fr,min-content] md:p-1" onSubmit={handleSubmit}>
            <div className="flex flex-1 flex-col gap-1">
              {component.inputLabel && (
                <label className="text-sm font-medium" htmlFor="service">
                  {component.inputLabel}
                </label>
              )}
              <input name={component.inputName} type="text" className="w-full rounded-lg bg-background-neutral px-3 py-3 lg:w-86 xl:w-96" />
            </div>
            <div className="flex flex-col justify-end">
              <button
                className="flex-shrink-0 whitespace-nowrap rounded-lg bg-elty-blue py-3 font-semibold text-white transition-colors hover:bg-brandBlue-600 focus:bg-brandBlue-600 md:px-3.5"
                type="submit"
                aria-label={component.callToActionLabel}
              >
                <span>{component.callToActionLabel}</span>
              </button>
            </div>
            {component.bottomLabel && <p className="text-sm text-text-body md:col-span-3">{component.bottomLabel}</p>}
          </form>
        </div>
      </div>
    </section>
  );
};
